export const CSS_CLASSES = {
  NOTIFICATIONS_ROOT: "notifications",
  NOTIFICATION_ROOT: "notification",
  NOTIFICATION_FLOATING_ROOT: "notification-floating",
  NOTIFICATION_INLINE_ROOT: "notification-inline",
  NOTIFICATION_WITH_CLOSE_BUTTON: "notification-with-close-button",
  NOTIFICATION_CONTENT: "notification-content",
  NOTIFICATION_CLOSE_BUTTON: "notification-close-button",
  NOTIFICATION_SMALL_CLOSE_BUTTON: "notification-small-close-button",
  NOTIFICATION_MEDIUM_CLOSE_BUTTON: "notification-medium-close-button",
  NOTIFICATION_LARGE_CLOSE_BUTTON: "notification-large-close-button",
  NOTIFICATION_SMALL_ACTIONS: "notification-small-actions",
  NOTIFICATION_MEDIUM_ACTIONS: "notification-medium-actions",
  NOTIFICATION_LARGE_ACTIONS: "notification-large-actions",
  NOTIFICATION_INFO: "notification-info",
  NOTIFICATION_SUCCESS: "notification-success",
  NOTIFICATION_ERROR: "notification-error",
  NOTIFICATION_WARNING: "notification-warning",
};
